<template>
  <div class="test">
    <Tree @click.native="nextStep" :class="classObject" />
    <transition name="fade" mode="out-in">
      <div v-if="STEP_STATE === 0" :key="0" class="test__start">
        <p>Нажмите на ёлку, чтобы начать</p>
      </div>
      <Card v-if="STEP_STATE === 1" :key="1">
        <p>
          В конце 2020 года на связь с RosExpert вышли инопланетяне. Те самые,
          которые, как за сериалом, наблюдают за событиями, происходящими на
          Земле. Не удивительно, что сюжет сезона 2020 года показался им самым
          захватывающим из всех, что прошли к настоящему времени.
        </p>
        <p>
          Из-за разницы в межгалактическом времени инопланетные существа
          прекрасно знают, каким будет и будущий 2021. По вашему рассказу о том,
          каким был 2020 год, инопланетяне смогут безошибочно определить вашу
          главную траекторию в следующем, 2021 году. А самое главное — они
          увидят тот самый талант, который станет вашим двигателем и опорой на
          протяжении следующих 365 дней.
        </p>
        <p>
          Вместе с нашими инопланетными гостями мы зададим вам несколько
          вопросов. Будьте снисходительны к несовершенству их языка и незнанию
          каких-то названий или очевидных вещей. В конце концов именно сейчас мы
          можем о них рассказать.
        </p>
        <p>Готовы?</p>

        <button class="test__btn" @click.prevent="nextStep">Далее</button>
      </Card>

      <Card v-else-if="STEP_STATE === 2" :key="2">
        <div>
          <strong
            >Ну что же, вернемся к самому началу! Как вы встретили 2020
            год?</strong
          >
        </div>
        <QA :items="qa1" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <Card v-else-if="STEP_STATE === 3" :key="3">
        <div>
          <strong
            >Переводчики нам подсказывают — это называется «Новогодние
            каникулы»! Но вот они закончились. Вспомните свой первый день в
            офисе: коллеги возвращаются после отпусков. Кажется, приступить к
            работе будет нелегко – воспоминания о празднике так свежи! Что вы
            делали?</strong
          >
        </div>
        <QA :items="qa2" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <Card v-if="STEP_STATE === 4" :key="4">
        <div>
          <strong
            >Нам рассказали, что в этой части Земли февраль и март — особые
            месяцы. В это время одна часть людей дарит другой части людей
            подарки и угощения только за то, что они такие, какие есть. Что
            делали вы?</strong
          >
        </div>
        <QA :items="qa3" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <Card v-if="STEP_STATE === 5" :key="5">
        <div>
          <strong
            >Мы заметили, что весной на вашей планете начало происходить что-то
            странное. Вы стали проводить почти все свое время перед светящимися
            прямоугольниками разных размеров — часто даже разговаривать с ними.
            Расскажите, что это было?</strong
          >
        </div>
        <QA :items="qa4" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <Card v-if="STEP_STATE === 6" :key="6">
        <div>
          <strong
            >Так, эти светящиеся прямоугольники вам заменили почти все! Неужели
            и еду тоже? Вы перестали питаться? Научились перерабатывать в пищу
            световую энергию экранов?</strong
          >
        </div>
        <QA :items="qa5" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <Card v-if="STEP_STATE === 7" :key="7">
        <div>
          <strong
            >У нас множество вопросов. А что бы вы рекомендовали сделать, чтобы
            лучше понять все про людей в вашем земном 2020 году?
          </strong>
        </div>
        <QA :items="qa6" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <Card v-if="STEP_STATE === 8" :key="8">
        <div>
          <strong
            >Да… мы уже заметили, жизнь землян, порой, интереснее любого
            сериала! И расскажете вы об этом лучше всех сами, как у вас говорят,
            «из первых рук». Определенно, стоит пригласить вас к нам в гости!
            Каким транспортом предпочтете воспользоваться?</strong
          >
        </div>
        <QA :items="qa7" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <Card v-if="STEP_STATE === 9" :key="9">
        <div>
          <strong
            >Любая мечта рано или поздно становится реальностью! У нас осталось
            мало времени, наша связь с Землей вот-вот оборвется. Нам важно
            знать, чем же вам все-таки запомнится этот земной 2020 год?</strong
          >
        </div>
        <QA :items="qa8" @change="pickedAnswer" />
        <button @click="nextStepDouble" class="test__btn">Далее</button>
      </Card>

      <Card v-if="STEP_STATE === 10 && winnerBranch == 0" :key="10">
        <div>
          <strong
            >Пришло наше время прощаться. Может быть, вы оставите нам на память
            какой-то подарок? Мы создадим на нашей планете «Музей имени
            Земли».</strong
          >
        </div>
        <QA :items="qa9" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <Card v-if="STEP_STATE === 10 && winnerBranch == 1" :key="10">
        <div>
          <strong
            >Пришло наше время прощаться. Может быть, вы оставите нам на память
            какой-то подарок? Мы создадим на нашей планете «Музей имени
            Земли».</strong
          >
        </div>
        <QA :items="qa10" @change="pickedAnswer" />
        <button
          @click="nextStep"
          :class="{ disabled: !currentAnswer }"
          class="test__btn"
        >
          Далее
        </button>
      </Card>

      <div v-if="STEP_STATE === 11" :key="11" class="test__gift">
        <img @click="setWinner" src="../../public/image/gift.svg" alt="" />
      </div>

      <Result
        v-if="STEP_STATE === 12 && winner == 'inventor'"
        :key="13"
        name="inventor"
        src="inventor.gif"
        title="Изобретатель"
        desc="2021 год откроет в вас талант Изобретателя. Кто знает, может быть именно в этом году мир, наконец, получит самозастегивающиеся пуговицы и автомат для нанесения макияжа! Ваше желание делать мир удобнее и лучше будет неукротимым, а если рядом с вами будет Мечтатель — серия патентов за уникальные разработки украсит стены вашего дома. Вам не понадобятся учебники или инструкции. Вы ко всему придете опытным путем. Сверхскоростные вакуумные поезда или ракета для космических полетов устарели еще в прошлом году — наверняка вы придумаете что-то поинтереснее. После такого несомненно захочется написать в социальных сетях: «Как тебе такое, Илон Маск?»."
      />
      <Result
        v-if="STEP_STATE === 12 && winner == 'wizard'"
        :key="13"
        name="wizard"
        src="wizard.gif"
        title="Волшебник"
        desc="В 2021 году вы станете…. Волшебником! Кажется, 2020 год был слишком серьезным, поэтому без нотки мистики и волшебства не обойтись. Возможно, вы найдете магический предмет, который будет обращать ошибки в победы, составите рецепт таинственного напитка всезнания или бессмертия или просто вспомните заклинание, которое сможет зажечь в сердце каждого любовь, а в глазах — радость жизни. Ваш ореол таинственности и загадочности будет привлекать людей. Поэтому и Юрий Дудь, добившись интервью с вами, в конце обязательно спросит: «В чем ваша суперсила?»."
      />
      <Result
        v-if="STEP_STATE === 12 && winner == 'dreamer'"
        :key="13"
        name="dreamer"
        src="dreamer.gif"
        title="Мечтатель"
        desc="В 2021 году вы станете настоящим Мечтателем. Неопределенность перестанет существовать — вместе с великими визионерами мира вы сможете увидеть, как изменятся города и страны, предскажете архитектурные стили поселений на Марсе и технологические открытия, которые оставят далеко позади все, что может спрогнозировать самый мощный искусственный интеллект сегодня. В конце концов, именно Мечтатели открывают дорогу Изобретателям и Исследователям!  Возможно, перевезти мебель и уютно обосноваться в увиденном мире будущего непосредственно в 2021 году еще не получится, но увидеть новые горизонты и пути — определенно, да!"
      />
      <Result
        v-if="STEP_STATE === 12 && winner == 'traveler'"
        :key="13"
        name="traveler"
        src="traveler.gif"
        title="Путешественник"
        desc="В 2021 году вы станете настоящим Путешественником! Возможно, именно так повлияли на вас мартовские и майские маршруты 2020 года — турне из гостиной в кабинет или ралли балкон – прихожая. Определенно, дороги и неизведанные географии манят вас! Открывать мир с помощью карт Google — не для вас. Путешествие может быть только реальным. Обойти Москву по кольцу парков?  Добраться до сердца плато Путорана? Сойти с проторенных туристических троп Алтая и найти подтверждение существованию древних племен? Купить билет на Занзибар и Танзанию? Вы будете смело ставить точки на карте и планировать маршрут. А если обстоятельства заставят сойти с пути — вы всегда открыты к новым поворотам."
      />
      <Result
        v-if="STEP_STATE === 12 && winner == 'researcher'"
        :key="13"
        name="researcher"
        src="researcher.gif"
        title="Исследователь"
        desc="В 2021 году вы откроете в себе Исследователя. Вероятно, вы и в 2020 году замечали, что есть у вас шесть незаменимых помощников — «шестерка слуг, проворных удалых»: Как, Почему, Кто, Что, Когда и Где. Вместе с этой командой в Новом году вы сумеете добраться до сути самых сложных задач и найти разгадки крупнейшим парадоксам человечества: например, казавшемуся неизменным закону Мёрфи. Возможно, именно 2021 год вы вспомните как время, когда вы начали работать над темой, которая привела вас к Нобелевской премии!"
      />
      <Result
        v-if="STEP_STATE === 12 && winner == 'mastermind'"
        :key="13"
        name="mastermind"
        src="mastermind.gif"
        title="Вдохновитель"
        desc="2021 год откроет в вас талант Вдохновителя. Наверняка уже в уходящем году вы заметили, что ваше мнение в виртуальных созвонах в Zoom обретало какой-то новый вес. Все так — вы чутко и проницательно видите лучшее в людях, умеете найти единственно правильные слова, которые вселяют уверенность в своих силах и возможности любых невозможных свершений. Воодушевить близких на тотальную смену обстановки? Собрать удаленную команду, говорящую на разных языках и нацеленную на успех общего дела, — может быть, запуск нового «единорога», а может быть ... постановку оперы? Вы удивитесь, сколько единомышленников соберет любое ваше начинание! Кстати, вам уже позвонил Юрий Башмет с предложением совместного проекта?"
      />
    </transition>
  </div>
</template>

<script>
import Card from "./Card";
import QA from "./QA";
import Tree from "./Tree";
import Result from "./Result";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      winner: "",
      winnerBranch: null,
      currentAnswer: "",
      qa1: [
        {
          text:
            "Волшебно! Наконец исполнилась моя мечта — только природа, и никакой городской суеты!",
          value: ["wizard", "dreamer"]
        },
        {
          text:
            "Фантастически! Столько новых маршрутов, открытий! Мне кажется, мы были настоящими исследователями и искателями приключений!",
          value: ["inventor", "researcher"]
        },
        {
          text:
            "Незабываемо! Столько интересных гостей, столько интересных людей и знакомств!",
          value: ["traveler", "mastermind"]
        }
      ],
      qa2: [
        {
          text:
            "Точно помню – все получили поздравления с прошедшими праздниками, а заодно напоминание о текущих задачах и ближайшей встрече со своим руководителем. Наметился новый проект, пора бы начать готовиться к нему.",
          value: ["inventor", "researcher"]
        },
        {
          text:
            "Пока все собирались, у меня было время погрузиться в прогнозы аналитиков и футурологов, набросать пару-тройку сценариев на ближайшие лет пять и заглянуть за точку сингулярности, чтобы узнать, как будет там.",
          value: ["wizard", "dreamer"]
        },
        {
          text:
            "Лучшее начало рабочего года — устроить с коллегами чаепитие с гостинцами из дальних и ближних путешествий, обменяться впечатлениями о прошедших праздниках. А к работе все вернутся и без напоминаний!",
          value: ["traveler", "mastermind"]
        }
      ],
      qa3: [
        {
          text:
            "Дааа!.. В это время всегда столько цветов и подарков — это очень красиво! Хотя к чему рассказы? Давайте лучше вам все это покажу! У меня тут столько фотографий.",
          value: ["dreamer", "wizard"]
        },
        {
          text:
            "Ох, непростое время. Каждый год приходится задавать множество вопросов и перерывать весь интернет, чтобы узнать, чем же новым можно порадовать коллег в эти праздники. Считаю, что лучший подарок можно сделать только своими руками.",
          value: ["inventor", "researcher"]
        },
        {
          text:
            "Лучший подарок — ощущение счастья! В таких случаях всегда готовлю вдохновляющую речь.Так приятно видеть, как глаза коллег зажигаются радостью, а на лицах появляются улыбки!",
          value: ["traveler", "mastermind"]
        }
      ],
      qa4: [
        {
          text:
            "Ну как что? Это — «удаленка». Пожалуй, единственный способ оставаться на связи с коллегами, клиентами, друзьями, да и вообще со всем миром!",
          value: ["traveler", "mastermind"]
        },
        {
          text:
            "Да это и сейчас так. Для меня гаджеты — это 1000 и 1 способ снять стресс и «поймать дзен». Окно в большой мир.",
          value: ["dreamer", "wizard"]
        },
        {
          text:
            "Похоже, вы об интернете и онлайне. В первую очередь это — самые актуальные знания и ответы на все вопросы. Сейчас иначе нельзя — пропустишь что-то, и уже не догнать!",
          value: ["inventor", "researcher"]
        }
      ],
      qa5: [
        {
          text:
            "Ну, в каком-то смысле да! С онлайн-доставкой можно забыть о времени на кухне и баловать себя творениями лучших шеф-поваров.",
          value: ["dreamer", "wizard"]
        },
        {
          text:
            "Совсем наоборот — только свежеприготовленное дома! Мои завтраки, обеды и ужины стали поводом экспериментировать с рецептами со всего мира. Раньше и представить было нельзя, что смогу приготовить севиче или идеальный стейк.",
          value: ["inventor", "researcher"]
        },
        {
          text:
            "Никакие прямоугольники не заменят личного участия! Есть или готовить можно только в компании единомышленников. Вот я вижу, в вас есть настоящий талант в кулинарии! Что там у вас сейчас едят? Приготовите?",
          value: ["mastermind", "traveler"]
        }
      ],
      qa6: [
        {
          text:
            "Музеи, театры — хотя бы и онлайн. Язык искусства будет понятен всем!",
          value: ["dreamer", "wizard"]
        },
        {
          text:
            "Сериалы, сериалы и еще раз сериалы. Все, что вы хотели знать о людях — там. Вы уже умеете одновременно смотреть несколько сериалов?",
          value: ["mastermind", "traveler"]
        },
        {
          text:
            "Читайте рецензируемые научные издания — непредвзятость, точное знание, аргументированно и без ненужных эмоций. Кстати, и про то, как устроено наше питание в подробностях узнаете.",
          value: ["researcher", "inventor"]
        }
      ],
      qa7: [
        {
          text:
            "Спасибо за приглашение, но, боюсь, что в ближайшее время — только силой мысли.",
          value: ["dreamer", "wizard"]
        },
        {
          text:
            "Не будем изобретать колесо — давайте вы меня просто захватите с собой на обратном пути.",
          value: ["traveler", "mastermind"]
        },
        {
          text:
            "Это вопрос будущего. Ближайшего будущего. Я как раз обдумываю несколько разработок.",
          value: ["inventor", "researcher"]
        }
      ],
      qa8: [
        {
          text:
            "Такими долгожданными личными встречами в «реальном мире». Смотреть друг другу в глаза и делиться эмоциями — невозможно было представить, насколько это важно!",
          value: ["wizard", "dreamer"]
        },
        {
          text:
            "Открытиями ученых. Лучшие умы человечества объединились в исследовании вируса. Это ли не повод для восхищения!",
          value: ["inventor"]
        },
        {
          text:
            "Никогда раньше не приходилось учиться с такой скоростью! Мне кажется, я уже умею все: кодировать, управлять тысячами людей на расстоянии, делать ремонт, выращивать всевозможные фрукты и овощи, ездить на любом транспорте — от лошади до яхты, играть на фортепиано, гитаре и трубе!",
          value: ["researcher"]
        },
        {
          text:
            "Поразительным контрастом событий — никогда раньше великое не стояло так близко к абсурдному, а радостное — к печальному.",
          value: ["traveler", "mastermind"]
        }
      ],
      qa9: [
        {
          text:
            "Красота в простоте. Я дарю вам эту морскую раковину. В ней спрятан шум прибоя.",
          value: ["dreamer"]
        },
        {
          text:
            "Магический кристалл. Когда через него проходит луч света, он превращается в огонь! Вы когда-нибудь видели такое?",
          value: ["wizard"]
        },
        {
          text:
            "Возьмите этот альбом с репродукциями чертежей Леонардо да Винчи. Кажется, этот величайший художник и ученый прилетел откуда-то с вашей планеты!",
          value: ["inventor"]
        }
      ],
      qa10: [
        {
          text:
            "Подзорную трубу. В путешествии так важно видеть, куда направляешься!",
          value: ["traveler"]
        },
        {
          text:
            "Музык разных самых. Нет ничего лучше музыки — поддержит, вдохновит, придаст энергии!",
          value: ["mastermind"]
        },
        {
          text:
            "Блокнот — записывать свои вопросы! Именно вопросы и поиск ответов на них — самый мощный двигатель!",
          value: ["researcher"]
        }
      ]
    };
  },
  components: {
    Card,
    QA,
    Tree,
    Result
  },

  computed: {
    ...mapGetters(["STEP_STATE", "ANSWERS_STATE"]),

    classObject() {
      let obj = {};
      obj["tree_" + this.STEP_STATE] = this.STEP_STATE;
      return obj;
    }
  },

  methods: {
    ...mapActions(["CHANGE_STATE", "CHANGE_ANSWERS"]),

    nextStep() {
      if (this.currentAnswer !== "" && this.STEP_STATE >= 2) {
        this.CHANGE_ANSWERS(this.currentAnswer);
        this.CHANGE_STATE();
        this.currentAnswer = "";
      } else if (this.STEP_STATE < 2) {
        this.CHANGE_STATE();
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },

    nextStepDouble() {
      if (this.currentAnswer) {
        this.CHANGE_ANSWERS(this.currentAnswer);
        this.CHANGE_ANSWERS(this.currentAnswer);
        this.CHANGE_STATE();
        this.currentAnswer = "";
        this.choiceBranch();
      }
    },

    pickedAnswer(picked) {
      this.currentAnswer = picked;
    },

    viewResult() {
      this.CHANGE_STATE();
    },

    choiceBranch() {
      let result = Object.entries(this.ANSWERS_STATE).reduce((prev, cur) => {
        if (prev[1] > cur[1] || prev[1] == cur[1]) {
          return prev;
        }
        return cur;
      });

      if (
        result[0] === "wizard" ||
        result[0] === "dreamer" ||
        result[0] === "inventor"
      ) {
        this.winnerBranch = 0;
      } else if (
        result[0] == "traveler" ||
        result[0] == "researcher" ||
        result[0] == "mastermind"
      ) {
        this.winnerBranch = 1;
      }
    },

    setWinner() {
      let result = Object.entries(this.ANSWERS_STATE).reduce((prev, cur) => {
        if (prev[1] > cur[1] || prev[1] == cur[1]) {
          return prev;
        }
        return cur;
      });

      console.log(result[0]);

      this.winner = result[0];

      this.CHANGE_STATE();
    }
  }
};
</script>

<style lang="scss">
.test {
  $self: &;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  flex: 1;
  margin-top: -26px;
  position: relative;
  @media screen and (max-width: 992px) {
    margin-top: 0;
  }
  &__start {
    text-align: center;
    font-size: 21px;
    line-height: 25px;
    p {
      margin: 0;
    }
  }
  &__btn {
    margin-left: auto;
    transition: 0.3s;
    opacity: 1;
    user-select: none;
    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
  &__start {
    margin-top: auto;
    @media screen and (max-width: 992px) {
      margin-bottom: 0;
      font-size: 21px;
      line-height: 25px;
      font-weight: 300;
    }
  }
  &__gift {
    display: flex;
    align-items: center;
    height: 100%;

    img {
      cursor: pointer;
      animation: shake 1s infinite;
    }
  }

  &__result {
    img {
      width: 100%;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes shake {
  0% {
    transform: translate(3px, 0);
  }
  5%,
  15% {
    transform: translate(-3px, 0);
  }
  10%,
  20% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
